import React from 'react';
import { Avatar, Box, Chip, Container, Grid, Typography } from '@material-ui/core';
import { IAppDetailsView } from '../AppDetailsView';
import ReactPlayer from 'react-player';
import styled from 'styled-components';
import { getAppOverviewPriceType } from '../../../../components/AppCard/AppStoreUtils';

const HeaderMedia = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 575px;
    height: 351px;
    margin-left: 24px;
`;

const StyledAvatar = styled(Avatar)`
    width: 80px;
    height: 80px;

    img {
        object-fit: contain;
    }
`;

export const AppDetailsHeader = ({ listing }: IAppDetailsView) => {
    const businessName =
        listing?.organization?.businessName && listing?.organization?.businessName !== null
            ? listing?.organization.businessName
            : 'Developer';

    const screenShot =
        listing && listing?.screenShots && listing.screenShots?.length > 0
            ? listing.screenShots[0]
            : undefined;

    const spacingSize = 2;

    // TODO: Use cheapest
    const bookingFeePercentageOfDisplayedPlan = listing.pricePlans[0].plan.bookingFeePercentage;

    return (
        <Box bgcolor="rgba(29, 87, 199, 0.08)">
            <Container>
                <Box p={4}>
                    <Grid container justify="center" alignItems="center">
                        <Grid xs={12} sm={6} item>
                            <Box my={spacingSize}>
                                <StyledAvatar
                                    variant="rounded"
                                    alt={listing?.name}
                                    src={listing?.icon?.sourceUrl}
                                />
                            </Box>
                            <Box my={spacingSize}>
                                <Typography variant="h4">{listing?.name}</Typography>
                            </Box>
                            <Box my={spacingSize}>
                                <Typography variant="body1" color="textSecondary">
                                    {listing?.tagLine}
                                </Typography>
                            </Box>
                            <Grid direction="row">
                                <Box pr={1} component="span">
                                    <Chip
                                        label={`By ${businessName}`}
                                        style={{
                                            backgroundColor: '#D7E0F2',
                                            padding: '4px 16px',
                                            fontWeight: 'bold',
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Box my={spacingSize}>
                                <Typography variant="body1">
                                    {getAppOverviewPriceType(
                                        listing.chargeType,
                                        listing.oneTimeChargeAmount,
                                        listing.pricePlans,
                                        listing.freeTrialDays
                                    )}
                                </Typography>
                                {bookingFeePercentageOfDisplayedPlan ? (
                                    <Typography style={{ fontStyle: 'italic', fontSize: '1em' }}>
                                        + {bookingFeePercentageOfDisplayedPlan}% booking fee
                                    </Typography>
                                ) : null}
                            </Box>
                        </Grid>
                        <Grid xs={12} sm={6} item justify="center" alignItems="center">
                            <Box p={1} display="flex" justifyContent="flex-end" alignItems="center">
                                <HeaderMedia>
                                    {listing?.promoVideoUrl ? (
                                        <ReactPlayer
                                            url={listing?.promoVideoUrl}
                                            width={'100%'}
                                            height={'100%'}
                                            controls={true}
                                        />
                                    ) : (
                                        screenShot && (
                                            <img
                                                style={{
                                                    height: 'auto',
                                                    maxWidth: '100%',
                                                    borderRadius: '5px',
                                                }}
                                                alt={'app-logo'}
                                                src={screenShot.image.sourceUrl}
                                            />
                                        )
                                    )}
                                </HeaderMedia>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};
